"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportModal = void 0;
var Button_1 = __importDefault(require("@components/Button"));
var react_1 = __importStar(require("react"));
var Modal_1 = __importDefault(require("@common/components/Modal"));
var ReportForm_1 = require("@features/StatisticPage/components/ReportModal/ReportForm");
var react_i18next_1 = require("react-i18next");
function ReportModal(_a) {
    var domain = _a.domain, currentUserEmail = _a.currentUserEmail, teamName = _a.teamName;
    var _b = __read((0, react_1.useState)(false), 2), isOpen = _b[0], setIsOpen = _b[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.default, { text: t('statistics:REPORT_MODAL.EXPORT'), onClick: function () { return setIsOpen(!isOpen); } }),
        react_1.default.createElement(Modal_1.default, { isOpen: isOpen, setIsOpen: setIsOpen, modalContentClassName: "custom-modal-className" },
            react_1.default.createElement(ReportForm_1.ReportForm, { domain: domain, teamName: teamName, currentUserEmail: currentUserEmail, closeModal: function () { return setIsOpen(false); } }))));
}
exports.ReportModal = ReportModal;
